module.exports = __webpack_public_path__ + "img/dashboard-active.504341e8.svg";